<template>
    <div class="past-payments-table">
        <h2>Payments</h2>

        <template v-if="payments.length == 0 && !isBusy">
            <p>You haven't made any payments yet.</p>
        </template>
        <template v-else>

            <b-table responsive bordered striped hover :items="payments" :fields="fields" :busy="isBusy" :tbody-tr-class="rowClass">
                <template v-slot:cell(item)="data">
                    {{ data.item.descriptor }}
                </template>

                <template v-slot:cell(method)="data">
                    <template v-if="data.item.gateway == 'stripe'">
                        Card
                    </template>
                    <template v-else-if="data.item.gateway == 'Klarna'">
                        Klarna
                    </template>
                    <template v-else>
                        Other
                    </template>
                </template>

                <template v-slot:cell(status)="data">
                    <template v-if="data.item.success == true">
                        <span class="badge badge-success">Paid</span>
                    </template>
                    <template v-else>
                        <span class="badge badge-danger">Declined</span>
                    </template>
                </template>
            </b-table>

        </template>
    </div>
</template>

<script>
    export default {
        props: {
            userId: {
                type: Number,
                default: null
            },
        },

        data() {
            return {
                isBusy: true,
                payments: [],
                fields: [
                    {
                        key: 'stripe_charge_id',
                        label: 'Transaction ID',
                        sortable: false
                    },
                    {
                        key: 'item',
                        label: 'Item',
                        sortable: false
                    },
                    {
                        key: 'amountFormatted',
                        label: 'Amount',
                        sortable: true
                    },
                    {
                        key: 'status',
                        label: 'Status',
                        sortable: true
                    },
                    {
                        key: 'method',
                        label: 'Method',
                        sortable: true
                    },
                    {
                        key: 'createdAtFormatted',
                        label: 'Date',
                        sortable: true,
                    }
                ],
            }
        },

        mounted() {
            this.getPayments();
        },

        methods: {
            // Get the payments
            getPayments: function() {
                axios.get('/api/user/' + this.userId + '/payments')
                    .then((response) => {
                        this.payments = response.data;
                        this.isBusy = false;
                    });
            },

            // Colour rows
            rowClass(item, type) {
                if (!item || type !== 'row') return
                if (item.success == false) return 'table-danger'
            }
        }
    }
</script>
